import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=2ad00fe6&scoped=true&"
import script from "./TabMenu.vue?vue&type=script&lang=ts&"
export * from "./TabMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=2ad00fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad00fe6",
  null
  
)

export default component.exports